<template>
    <svg width="40" height="29" viewBox="0 0 40 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M39.7111 4.24261L35.4684 0L15.237 20.2314L4.24261 9.23706L0 13.4797L10.9944 24.4741L10.9943 24.4742L15.2369 28.7168L15.237 28.7167L15.2371 28.7168L19.4797 24.4742L19.4796 24.4741L39.7111 4.24261Z" fill="white"/>
    </svg>
</template>

<script>
export default {
	name: "Check"
};
</script>

